import styled, { css } from 'styled-components';
import { Flex } from '../flex/index.js';
import { Stack } from '../stack/index.js';
const getBorderColor = ({ theme, $hasFileOver, $hasError, }) => {
    if ($hasError)
        return theme.colors.borders.error;
    if ($hasFileOver)
        return theme.colors.borders.primary;
    return theme.colors.borders.default;
};
export const DropZoneInner = styled(Stack) ``;
export const UploaderActionsContainer = styled(Flex)(({ theme, $hasFileOver, $hasError }) => css `
    flex: 1;
    align-items: center;
    justify-content: center;
    background: ${$hasFileOver
    ? theme.colors.backgrounds.secondary
    : theme.colors.backgrounds.default};
    border-radius: ${theme.radii.x1_5};
    padding: ${theme.space.x6} 0;
    border-width: ${theme.borderWidths.sm};
    border-style: ${theme.borderStyles.solid};
    border-color: ${getBorderColor({ theme, $hasFileOver, $hasError })};
    min-width: ${theme.sizes.x60};

    & ${DropZoneInner} {
      pointer-events: ${$hasFileOver ? 'none' : 'unset'};
    }
  `);
//# sourceMappingURL=file-drop-zone.styles.js.map